import { domain } from "../auth/domain";

const authHeaders = () => {
  const token = localStorage.getItem("accessToken");
  if (!token) {
    throw new Error("Missing access token.");
  }
  return {
    "Content-Type": "application/json",
    Authorization: `JWT ${token}`,
  };
};

const handleResponse = async (response) => {
  if (!response.ok) {
    let message = "Failed to process request.";
    try {
      const payload = await response.json();
      if (payload?.detail) {
        message = payload.detail;
      } else if (typeof payload === "object") {
        message = Object.values(payload)
          .map((value) => (Array.isArray(value) ? value.join(" ") : value))
          .join(" ");
      }
    } catch (_error) {
      // ignore response parsing errors
    }
    throw new Error(message);
  }

  if (response.status === 204) {
    return null;
  }

  return response.json();
};

export const fetchSystemAccessStatus = async () => {
  const response = await fetch(`${domain}profiles/system-access/`, {
    method: "GET",
    headers: authHeaders(),
  });
  return handleResponse(response);
};

export const acceptTermsAndConditions = async () => {
  const response = await fetch(`${domain}profiles/accept-terms/`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ agreed: true }),
  });
  return handleResponse(response);
};

export const refreshSystemSession = async () => {
  const response = await fetch(`${domain}profiles/refresh-session/`, {
    method: "POST",
    headers: authHeaders(),
  });
  return handleResponse(response);
};
